import { type TDispatchStructuredLogUserEngagement } from '../types/adscopilot-structured-log-types';
import { createStructureLogUserEngagement } from './create-structured-log-user-engagement';
import { dispatchStructuredLogEvent } from './dispatch-structured-log-event';

const ValidEventNameList = ['directHandoffInitiate', 'handoffInitiate'];
const ValidActivityTypeList = ['endOfConversation', 'conversationResume'];

export const dispatchStructuredLogUserEngagementEvent: TDispatchStructuredLogUserEngagement = (params) => {
  const { activity, options } = params;

  const isMessageRestored = (activity as any).isFromRestore === true;
  const isEventValid = (activity as any).type === 'event' && ValidEventNameList.includes((activity as any).name);
  const isActivityTypeValid = ValidActivityTypeList.includes(activity.type);

  const isThumbsUpClicked = !!options?.thumbsUpClicked;
  const isThumbsDownClicked = !!options?.thumbsDownClicked;
  const isthumbsDownFeedback = !!options?.thumbsDownFeedback;
  const isLiveAgentPostChatSurveyResponse = !!options?.liveAgentPostChatSurveyResponse;
  const isInChatFeedbackSurveyResponse = !!options?.inChatFeedbackSurveyResponse;
  const isInChatFeedbackSurveyDismissed = !!options?.inChatFeedbackSurveyDismissed;
  const isInChatFeedbackSurveyShown = !!options?.inChatFeedbackSurveyShown;
  const isLiveAgentQueueSelected = !!options?.liveAgentQueueSelected;
  const isCopyClicked = !!options?.copyClicked;
  const isLearnMoreLinkClicked = !!options?.learnMoreLinkClicked;
  const isSiteLinkClicked = !!options?.siteLinkClicked;
  const isMessagePopoverClicked = !!options?.messagePopoverClicked;
  const isPromptStarterItemClicked = !!options?.promptStarterItemClicked;
  const isPromptLibraryItemClicked = !!options?.promptLibraryItemClicked;
  const isPromptPreferenceClicked = !!options?.promptPreferenceClicked;
  const isPromptPreferenceSavedCount = !!options?.promptPreferenceSavedCount;
  const isSignInLinkClicked = !!options?.signInLinkClicked;
  const isSignUpLinkClicked = !!options?.signUpLinkClicked;
  const isChatTriggered = !!options?.chatTriggerSource;
  const isTestYourTagToolWebsiteConfirmed = !!options?.testYourTagToolWebsiteConfirmed;
  const isTestYourTagToolCompleted = !!options?.testYourTagToolCompleted;
  const isCaptchaEvent = !!options?.captchaEvent;

  if (isMessageRestored) return;
  if (
    !isEventValid
    && !isActivityTypeValid
    && !isThumbsUpClicked
    && !isThumbsDownClicked
    && !isthumbsDownFeedback
    && !isCopyClicked
    && !isMessagePopoverClicked
    && !isLearnMoreLinkClicked
    && !isSiteLinkClicked
    && !isLiveAgentQueueSelected
    && !isLiveAgentPostChatSurveyResponse
    && !isInChatFeedbackSurveyResponse
    && !isInChatFeedbackSurveyDismissed
    && !isInChatFeedbackSurveyShown
    && !isChatTriggered
    && !isPromptStarterItemClicked
    && !isPromptLibraryItemClicked
    && !isPromptPreferenceClicked
    && !isPromptPreferenceSavedCount
    && !isSignInLinkClicked
    && !isSignUpLinkClicked
    && !isTestYourTagToolWebsiteConfirmed
    && !isTestYourTagToolCompleted
    && !isCaptchaEvent
  ) return;

  const structuredLogMessage = createStructureLogUserEngagement(params);
  dispatchStructuredLogEvent(structuredLogMessage);
};
